import React from 'react';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import {
  HVACampaignPerformanceDataTable,
  campaignPerformanceDataTableColumns
} from 'components/tables/HVACampaignPerformanceDataTable';

interface PerformanceData {
  bxpcampaignid: number;
  date: string;
  // eslint-disable-next-line
  campaigndata: any;
}

interface CampaignPerformanceDataProps {
  data: PerformanceData[];
}

const CampaignPerformanceData: React.FC<CampaignPerformanceDataProps> = ({
  data
}) => {
  const columns = campaignPerformanceDataTableColumns(data);

  const table = useAdvanceTable({
    data,
    columns,
    pageSize: 15,
    pagination: true,
    sortable: true,
    selection: false
  });

  return (
    <div>
      <div className="mt-0 bg-body-emphasis pb-3">
        <AdvanceTableProvider {...table}>
          <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 border-translucent position-relative top-1">
            <HVACampaignPerformanceDataTable />
          </div>
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default CampaignPerformanceData;
